import {messages} from '@smartmixin/i18n';
import {MessageDescriptor} from 'react-intl';

export const metricToMessage: Record<string, MessageDescriptor> = {
  T: messages.units.temperature,
  U: messages.units.humidity,
  FF: messages.units.wind,
  SLP: messages.units.pressure,
  RR_1H: messages.units.precipitation,
  RR_3H: messages.units.precipitation,
  RR_6H: messages.units.precipitation,
  RR_12H: messages.units.precipitation,
  RR_24H: messages.units.precipitation,
  SOLAR_RADIATION: messages.units.solarRadiation,
  UV: messages.units.uv,
  VIS: messages.units.visibility,
  AQI: messages.units.AQI,
  PM_1: messages.units.PM_1,
  PM_10: messages.units.PM_10,
  PM_2P5: messages.units.PM_2P5,
  LIGHTNING_STRIKE_COUNT: messages.units.lightningStrikeCount,
};
